import { useFormikContext } from 'formik';
import { Card } from '../../../../card/Card';
import {
  PipelineSettingsFormFields,
  PipelineSettingsFormState
} from '../../interfaces/pipeline-settings-form-state';
import { useAnalyticsTracker } from '../../../../tracking/hooks/useAnalyticsTracker';
import { PipelineSettingsTrackers } from '../../../tracking/pipeline-settings-trackers';
import { PIPELINE_DESTINATION_TABLE_SETTINGS_MODES } from '../../constants/pipeline-settings';
import { PipelineConfigRadioGroupWrapper } from '../PipelineConfigRadioGroupWrapper/PipelineConfigRadioGroupWrapper';
import { PipelineDestinationTableSettingsFeatureOptions } from '../../../interfaces/pipeline-settings-config';

export function DestinationTableSettings({
  disabled,
  featureOptions
}: {
  disabled?: boolean;
  featureOptions: PipelineDestinationTableSettingsFeatureOptions;
}) {
  const formikProps = useFormikContext<PipelineSettingsFormState>();
  const { eventTrack } = useAnalyticsTracker();
  const configModes = PIPELINE_DESTINATION_TABLE_SETTINGS_MODES.filter(
    mode => !mode.isComingSoon && featureOptions.options.findIndex(o => o.value === mode.value) >= 0
  );

  if (configModes.length <= 1) {
    return null;
  }

  return (
    <Card
      gridColumns={1}
      className='mt-5'
      title='Destination Table Setting for Historical Load'
      dataId='destination-table-settings'
    >
      <PipelineConfigRadioGroupWrapper
        id='destination-table-settings'
        name={PipelineSettingsFormFields.DESTINATION_TABLE_SETTINGS}
        defaultValue={formikProps.values[PipelineSettingsFormFields.DESTINATION_TABLE_SETTINGS]}
        currentValue={formikProps.values[PipelineSettingsFormFields.DESTINATION_TABLE_SETTINGS]}
        className='grid-column-span-1'
        row={false}
        configModes={configModes}
        onChange={async mode => {
          eventTrack({
            action:
              PipelineSettingsTrackers.PIPELINE_TRACKER_PIPELINE_SETTINGS_DESTINATION_TABLE_SETTINGS_CHANGE,
            properties: {
              mode
            }
          });

          await formikProps.setFieldValue(
            PipelineSettingsFormFields.DESTINATION_TABLE_SETTINGS,
            mode
          );
        }}
        disabled={disabled}
      />
    </Card>
  );
}
